import { SmartSendItemApiModel } from '~/lib/api/smartsend/types';
import ItemMarketplaceDetails from './ItemMarketplaceDetails';
import ItemRecipient from './ItemRecipient';
import { P2GGrid } from '@parcel2go/core-ui';
import { P2GBox } from '@parcel2go/core-ui';
import ItemContents from './ItemContents';
import { SmartSendItemSelect } from '../SmartSendItemSelect';
import { EditType } from './EditType';
import { P2GLink } from '@parcel2go/core-ui';
import SmartSendOrderProcessOrderDrop from './SmartSendOrderProcessOrderDrop';

import { EventSections } from '../../../lib/events/EventLogger';
import P2GContentDropDown from '../../P2GContentDropDown';
import { Trans, useTranslation } from 'react-i18next';
import { TranslationNamespaces } from '~/lib/constants';
import { GetExternalTrackingNumber } from '~/apps/smartsend/lib/helpers/SmartSendSummaryGenerator';

import ItemBookedService from './ItemBookedService';

interface props {
  item: SmartSendItemApiModel;
  arrangeReturn?: () => void;
  toggleSelect: (val: boolean) => void;
  edit: (type: EditType) => void;
  isReturn: boolean;
}

export default function SmartSendOrderProcessOrder(props: props) {
  const trackingNumber = GetExternalTrackingNumber(props.item);
  const { t } = useTranslation(TranslationNamespaces.SMARTSEND);

  const edit = () => {
    props.edit && props.edit('ORDER-ACTIONS');
  };

  const viewTracking = () => {
    props.edit && props.edit('ORDER-TRACKING');
  };

  const viewDetails = () => {
    props.edit && props.edit('ORDER-DETAILS');
  };

  const viewLabels = () => {
    props.edit && props.edit('ORDER-LABELS');
  };

  return (
    <div>
      <P2GBox p={1}>
        <SmartSendItemSelect selected={props.item.State.selected} toggle={props.toggleSelect}>
          <P2GGrid container spacing={1}>
            <P2GGrid item xs={12} sm={6} md={4} lg={4}>
              <ItemContents edit={edit} item={props.item} revealText={t('VIEW_LINK', 'View')} variant="body2" />
            </P2GGrid>
            <P2GGrid item xs={12} sm={6} md={3} lg={3}>
              <ItemRecipient
                edit={edit}
                customer={props.isReturn ? props.item.Sender : props.item.Recipient}
                revealText={t('VIEW_LINK', 'View')}
                variant="body2"
              />
            </P2GGrid>
            <P2GGrid item sm={12} md={5} lg={5}>
              {props.item.BookingDetails?.Service && (
                <ItemBookedService
                  trackingNumber={trackingNumber}
                  item={props.item}
                  viewTracking={viewTracking}
                  viewActions={edit}
                  viewDetails={viewDetails}
                  variant="body2"
                />
              )}
            </P2GGrid>
          </P2GGrid>
        </SmartSendItemSelect>
      </P2GBox>
      <ItemMarketplaceDetails
        section={EventSections.SmartSend}
        action={null}
        item={props.item}
        removeTag={null}
        saveTags={null}
        drop={
          <P2GContentDropDown
            control={
              <P2GLink variant="body2">
                <Trans t={t} i18nKey="QUICK_ACTIONS_LINK" defaults="Quick<br />Actions" />
              </P2GLink>
            }
          >
            <SmartSendOrderProcessOrderDrop
              direction="column"
              viewDetails={edit}
              viewLabels={viewLabels}
              viewTracking={viewTracking}
              arrangeReturn={props.arrangeReturn}
            />
          </P2GContentDropDown>
        }
      />
    </div>
  );
}
